import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users } from "lucide-react";

interface CustomerUsersTabProps {
  tenantId: string;
}

export function CustomerUsersTab({ tenantId }: CustomerUsersTabProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Users</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col items-center justify-center py-12 text-center">
          <Users className="h-12 w-12 text-muted-foreground mb-4" />
          <h3 className="text-lg font-semibold">User Management Coming Soon</h3>
          <p className="text-muted-foreground mt-2 max-w-md">
            This feature will allow you to view and manage users for this
            customer account, including inviting new users and managing roles.
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
